import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from '@/lib/themes';

import { store } from '@/store';
import AppRoutes from '@/app.routes';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import './app.css';
import LogRocket from 'logrocket';
import { env, isStaging } from 'lib/utils/env';

const queryClient = new QueryClient();

function App() {
  if (isStaging && env.LOGROCKET_ID) {
    LogRocket.init(env.LOGROCKET_ID);
  }
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
          <Provider store={store}>
            <AppRoutes />
          </Provider>
        </Router>
      </ThemeProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
